export const siteSettings = {
  name: "Global Tech Markets",
  link: "https://globaltechmarket.live",
  email: "support@globaltechmarket.live",
  appLink: "https://app.globaltechmarket.live",
};
